import { render } from "./ModalInformationTypeComponent.vue?vue&type=template&id=6775a026&scoped=true"
import script from "./ModalInformationTypeComponent.vue?vue&type=script&lang=js"
export * from "./ModalInformationTypeComponent.vue?vue&type=script&lang=js"

import "./ModalInformationTypeComponent.vue?vue&type=style&index=0&id=6775a026&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6775a026"]])

export default __exports__